module.exports = __webpack_public_path__ + "static/media/massey_ferguson.cf6f6aa3.png";